<script setup>
import { LicenseStatus } from '@pfsc/core/models/license-status';
import { MultipleLookupConfig } from '@pfsc/core/models/multiple-lookup-config';
import { LookupOptions, lookupService } from '@pfsc/core/services/lookup.service';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import MultipleLookup from './multiple-lookup.vue';

defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
});

const emits = defineEmits(['update:model-value']);

const config = new MultipleLookupConfig({
  title: globalTranslate('lookup.attendanceStatus'),
  fetch: () => lookupService.getLicenseStatuses(new LookupOptions({ isClassRegistration: true })),
  toReadable: LicenseStatus.toReadable,
});

</script>
<template>
  <multiple-lookup
    :model-value="modelValue"
    :config="config"
    @update:model-value="emits('update:model-value', $event)"
  />
</template>
